<script>
  import viewport from '@/js/utils/useViewportAction.js';

  export let funding;
  export let contact;
  let grow = false;
</script>

<section class="funding-wrapper container container--large">
  <div
    class="funding"
    class:grow
    use:viewport
    on:enterViewport={() => (grow = true)}
  >
    <div class="funding__image">
      <img
        src={funding.image.src}
        width={funding.image.width}
        height={funding.image.height}
        alt={funding.image.alt}
        loading="lazy"
      />
      <div class="funding__image-mask" />
    </div>
    <div class="funding__content">
      <h3 class="funding__title">{funding.title}</h3>
      <p class="funding__desc text-small">{funding.desc}</p>
      <div class="funding__contact">
        <div class="funding__contact-image">
          <img
            src={contact.image.src}
            width={contact.image.width}
            height={contact.image.height}
            alt={contact.image.alt}
            loading="lazy"
          />
        </div>
        <div class="funding__contact-info">
          <h5 class="funding__contact-name">{contact.name}</h5>
          <p class="funding__contact-title text-small">{contact.title}</p>
          <p class="funding__contact-phone text-micro">{contact.phone}</p>
          <a
            class="funding__contact-email text-link text-micro"
            href={contact.link.url}><span>{contact.link.text}</span></a
          >
        </div>
      </div>
    </div>
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .funding-wrapper {
    margin: 0 auto 10rem;
    padding-top: 10rem;
    border-top: solid 1px $light-border;
    padding-bottom: 0;

    @include resp-max('s') {
      padding-top: 6rem;
      margin-bottom: 4rem;
    }
  }
  .funding {
    background-color: var(--white);
    border-radius: 4rem 0;
    display: flex;
    position: relative;
    overflow: hidden;
    --black: 0, 0, 0;
    box-shadow: 3px 3px rgba(var(--black), 0.02);

    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    @include resp-max('m') {
      flex-direction: column;
    }

    &__image {
      aspect-ratio: 76/60;
      overflow: hidden;
      min-width: 58%;
      position: relative;

      @include resp-max('m') {
        max-width: 100%;
        width: 100%;
      }

      img {
        object-fit: cover;
        height: 100%;
        width: 100%;
      }

      &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: url(img/noise.png) 300px 300px;

        @include resp-max('s') {
          display: none;
        }
      }

      &-mask {
        position: absolute;
        width: 100%;
        height: 100%;
        inset: 0;
        opacity: 0.8;
        background: linear-gradient(to top, #575757 0%, rgba(0, 0, 0, 0) 100%);

        @include resp-max('s') {
          display: none;
        }
      }
    }

    &__content {
      padding: 6.85rem 8rem;

      @include resp-max('l') {
        padding: 5rem;
      }

      @include resp-max('s') {
        padding: 5rem 1rem;
      }
    }

    &__title {
      @include resp-max('s') {
        @include h2;
        text-align: center;
      }
    }

    &__desc {
      color: var(--royal-light);
      margin-top: 1.8rem;

      @include resp-max('s') {
        color: var(--royal);
        text-align: center;
      }
    }

    &__contact {
      margin-top: 5rem;
      padding-top: 5rem;
      display: flex;
      gap: 3rem;
      border-top: solid 1px $light-border;

      @include resp-max('s') {
        margin-top: 6.5rem;
        padding-top: 0;
        border-top: unset;
      }

      @include resp-max('xs') {
        gap: 1.5rem;
      }
      &-image {
        width: 12.7rem;
        height: 12.7rem;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;

        img {
          object-fit: cover;
          height: 100%;
          width: 100%;
          place-content: center;
        }
      }

      &-info {
        border-left: 1px solid $light-border;
        padding-left: 3rem;

        @include resp-max('xs') {
          padding-left: 1.5rem;
        }
      }

      &-name {
      }

      &-title {
        color: var(--royal-light);
      }

      &-phone {
        margin-top: 1rem;
      }

      &-email {
        color: var(-grey);
      }
    }
  }
</style>
